/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FlightSeatOption } from "./FlightSeatOption";
import {
  FlightSeatOptionFromJSON,
  FlightSeatOptionFromJSONTyped,
  FlightSeatOptionToJSON,
  FlightSeatOptionToJSONTyped,
} from "./FlightSeatOption";

/**
 *
 * @export
 * @interface FlightSeatElement
 */
export interface FlightSeatElement {
  /**
   *
   * @type {string}
   * @memberof FlightSeatElement
   */
  cabinClass: string;
  /**
   *
   * @type {number}
   * @memberof FlightSeatElement
   */
  deck: number;
  /**
   *
   * @type {number}
   * @memberof FlightSeatElement
   */
  rowIndex: number;
  /**
   *
   * @type {number}
   * @memberof FlightSeatElement
   */
  sectionIndex: number;
  /**
   *
   * @type {number}
   * @memberof FlightSeatElement
   */
  elementIndex: number;
  /**
   *
   * @type {string}
   * @memberof FlightSeatElement
   */
  type: string;
  /**
   *
   * @type {string}
   * @memberof FlightSeatElement
   */
  designator?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof FlightSeatElement
   */
  disclosures: Array<string>;
  /**
   *
   * @type {Array<FlightSeatOption>}
   * @memberof FlightSeatElement
   */
  options: Array<FlightSeatOption>;
}

/**
 * Check if a given object implements the FlightSeatElement interface.
 */
export function instanceOfFlightSeatElement(
  value: object
): value is FlightSeatElement {
  if (!("cabinClass" in value) || value["cabinClass"] === undefined)
    return false;
  if (!("deck" in value) || value["deck"] === undefined) return false;
  if (!("rowIndex" in value) || value["rowIndex"] === undefined) return false;
  if (!("sectionIndex" in value) || value["sectionIndex"] === undefined)
    return false;
  if (!("elementIndex" in value) || value["elementIndex"] === undefined)
    return false;
  if (!("type" in value) || value["type"] === undefined) return false;
  if (!("disclosures" in value) || value["disclosures"] === undefined)
    return false;
  if (!("options" in value) || value["options"] === undefined) return false;
  return true;
}

export function FlightSeatElementFromJSON(json: any): FlightSeatElement {
  return FlightSeatElementFromJSONTyped(json, false);
}

export function FlightSeatElementFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightSeatElement {
  if (json == null) {
    return json;
  }
  return {
    cabinClass: json["cabin_class"],
    deck: json["deck"],
    rowIndex: json["row_index"],
    sectionIndex: json["section_index"],
    elementIndex: json["element_index"],
    type: json["type"],
    designator: json["designator"] == null ? undefined : json["designator"],
    disclosures: json["disclosures"],
    options: (json["options"] as Array<any>).map(FlightSeatOptionFromJSON),
  };
}

export function FlightSeatElementToJSON(json: any): FlightSeatElement {
  return FlightSeatElementToJSONTyped(json, false);
}

export function FlightSeatElementToJSONTyped(
  value?: FlightSeatElement | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    cabin_class: value["cabinClass"],
    deck: value["deck"],
    row_index: value["rowIndex"],
    section_index: value["sectionIndex"],
    element_index: value["elementIndex"],
    type: value["type"],
    designator: value["designator"],
    disclosures: value["disclosures"],
    options: (value["options"] as Array<any>).map(FlightSeatOptionToJSON),
  };
}
